<template>
    <div class="v-sidebar" v-show="active">
        <div class="v-sidebar__background" @click="close"></div>
        <div class="v-sidebar__content"
             :class="{'v-sidebar__content--active': active}"
             :style="{width: sidebarWidth}"
        >
            <div ref="header" class="v-sidebar__header" v-if="$slots.header">
                <slot name="header"></slot>
            </div>

            <div class="v-sidebar__default" :style="{height: sidebarHeight}">
                <slot name="default"></slot>
            </div>

            <div ref="footer" class="v-sidebar__footer" v-if="$slots.footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'v-sidebar',

    props: {
        active: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: () => '300px'
        }
    },

    watch: {
        width: {
            handler(val) {
                this.sidebarWidth = val
            },
            immediate: true
        },

        active(isActive) {
            if (isActive) {
                window.addEventListener('resize', this._windowResize)
                this.$nextTick(() => {
                    this._innerHeight(window.innerHeight)
                })
            } else {
                window.removeEventListener('resize', this._windowResize)
            }
        }
    },

    data() {
        return {
            sidebarHeight: null,
            sidebarWidth: '300px',
            _class: 'v-sidebar'
        }
    },

    methods: {
        close() {
            this.$emit('close')
        },

        _innerHeight(height) {
            const header = this.$refs.header ? this.$refs.header.clientHeight : 0
            const footer = this.$refs.footer ? this.$refs.footer.clientHeight : 0

            this.sidebarHeight = (height - (this.$slots.header ? header : 0) - (this.$slots.footer ? footer : 0)) + 'px'
        },

        _windowResize(event) {
            this.$nextTick(() => {
                this._innerHeight(event.target.innerHeight)
            })
        }
    }
}
</script>

<style lang="scss">
@keyframes active-sidebar {
    from {
        transform: translateX(100%);
    }
    to {
        transform: translateX(0%);
    }
}

.v-sidebar {
    --sidebar-content-padding: 15px;
    --sidebar-bg-color: #fff;

    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    z-index: 99999;

    &__background {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: transparent;
    }

    &__content {
        position: absolute;
        box-shadow: 0 0 11px 0 rgba(0,0,0,0.25);
        transform: translateX(100%);
        background-color: var(--sidebar-bg-color);
        z-index: 99999;
        right: 0;
        height: 100vh;

        &--active {
            animation-name: active-sidebar;
            animation-duration: .5s;
            animation-fill-mode: forwards;
        }
    }

    &__header {
        padding: var(--sidebar-content-padding);
        text-align: center;
        font-size: 20px;
    }

    &__default {
        padding: var(--sidebar-content-padding);
        overflow: auto;
    }

    &__footer {
        padding: var(--sidebar-content-padding);
    }
}
</style>
